import SvgIcon from './SvgIcon.vue';
import MfNotificationsBadge from './MfNotificationsBadge.vue';
export default {
  name: 'MfIcon',
  components: {
    SvgIcon,
    MfNotificationsBadge
  },
  props: {
    /**
     * data-cy para o cypress
     */
    dataCy: {
      type: String,
      default: 'mf-icon'
    },
    /**
     * Nome do ícone
     */
    icon: {
      type: String,
      default: ''
    },
    /**
     * Cor do ícone
     */
    color: {
      type: String,
      default: 'cinza-0'
    },
    /**
     * Tamanho em pixels do ícone (default equivalente ao v-icon)
     */
    size: {
      type: [Number, String],
      default: 24
    },
    /**
     * Atalho para tamanho de 12px no padrão do Vuetify
     */
    xSmall: {
      type: Boolean,
      default: false
    },
    /**
     * Atalho para tamanho de 16px no padrão do Vuetify
     */
    small: {
      type: Boolean,
      default: false
    },
    /**
     * Atalho para tamanho de 20px no padrão do Vuetify
     */
    dense: {
      type: Boolean,
      default: false
    },
    /**
     * Atalho para tamanho de 36px no padrão do Vuetify
     */
    large: {
      type: Boolean,
      default: false
    },
    /**
     * Atalho para tamanho de 40px no padrão do Vuetify
     */
    xLarge: {
      type: Boolean,
      default: false
    },
    /* Configurações exclusivas para o Material Symbols */
    /**
     * Variante do ícone
     */
    variant: {
      type: String,
      default: 'rounded',
      validator: value => ['', 'outlined', 'rounded', 'sharp'].includes(value)
    },
    /**
     * Preenchimento do ícone (0 não preenchido | 1 preenchido)
     */
    fill: {
      type: Boolean,
      default: false
    },
    /**
     * Largura da borda do ícone. Mesma funcionalidade do weight da fonte normal
     */
    wght: {
      type: [Number, String],
      default: 400
    },
    /**
     * Grad auxilia o weight na grossura do ícone, porém com menos impacto
     */
    grad: {
      type: [Number, String],
      default: 0
    },
    /**
     * Auxilia na escala do ícone
     */
    opsz: {
      type: [Number, String],
      default: 24
    },
    /**
     * conjunto de eventos 'on' do vuetify
     */
    on: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * bind de atributos do vuetify
     */
    attrs: {
      type: Object,
      default() {
        return {};
      }
    },
    /**
     * Show notification circle
     */
    showNotification: {
      type: Boolean,
      default: false
    },
    /**
     * Show notification circle
     */
    notificationBadgeSize: {
      type: String,
      default: 'small',
      validator: value => ['small', 'medium', 'large'].includes(value)
    },
    /**
     * Number of notifactions
     */
    notificationsCounter: {
      type: Number,
      default: 0
    }
  },
  emits: ['click', 'mouseleave', 'mouseover'],
  computed: {
    usingSlot() {
      return Boolean(this.$slots?.default && typeof this.$slots.default === 'function');
    },
    getIcon() {
      if (this.$options._isBeingDestroyed || this.$options._isDestroyed) {
        return this.icon;
      }
      if (this.usingSlot && this.$slots.default) {
        try {
          // No Vue 3, slots são funções
          const slotResult = this.$slots.default();
          if (slotResult && slotResult[0]) {
            const slotContent = slotResult[0];
            if (typeof slotContent === 'string') {
              return slotContent;
            }
            if (slotContent && slotContent.text) {
              return slotContent.text;
            }
            if (slotContent && slotContent.children && slotContent.children[0]) {
              return slotContent.children[0];
            }
          }
        } catch {
          return this.icon;
        }
      }
      return this.icon;
    },
    getColorStyle() {
      if (this.color && this.color.startsWith('#')) {
        return this.color;
      }
      return `rgb(var(--v-theme-${this.color}))`;
    },
    getMaterialDesignStyle() {
      return `font-variation-settings: 'FILL' ${this.getFill}, 'wght' ${this.wght},'GRAD' ${this.grad}, 'opsz' ${this.opsz}; font-size: ${this.getSize}px; color: ${this.getColorStyle}`;
    },
    getFill() {
      return this.fill ? 1 : 0;
    },
    getSize() {
      if (this.xSmall) return 12;
      if (this.small) return 16;
      if (this.dense) return 20;
      if (this.large) return 36;
      if (this.xLarge) return 40;
      return this.size;
    },
    isIconFromMfIcons() {
      const mfIcons = ['whatsapp', 'whatsapp-business', 'record', 'processing'];
      return mfIcons.includes(this.getIcon.trim());
    }
  }
};